module.exports = __webpack_public_path__ + "static/media/18.cbe49077.jpg";